import axios from './axiosService';

export default {
  async getDomains() {
    const {data} = await axios.get(`/api/mailgun/admin/domains`)
    return data;
  },
  async getIPAddresses() {
    const {data} = await axios.get(`/api/mailgun/ip-addresses`)
    return data;
  },
  async getIPAddress(ipAddress) {
    const {data} = await axios.get(`/api/mailgun/ip-addresses/${ipAddress}`)
    return data;
  },
  async getDomainsFor(ipAddress) {
    const {data} = await axios.get(`/api/mailgun/ip-addresses/${ipAddress}/domains`)
    return data;
  },
  async getIPPools() {
    const {data} = await axios.get(`/api/mailgun/ip-pools`)
    return data;
  },
  async getIPPool(ipPool) {
    const {data} = await axios.get(`/api/mailgun/ip-pools/${ipPool}`)
    return data;
  },
}
